import { render, staticRenderFns } from "./priceDescription.vue?vue&type=template&id=f1414536&scoped=true"
import script from "./priceDescription.vue?vue&type=script&lang=js"
export * from "./priceDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1414536",
  null
  
)

export default component.exports